import React from "react";
import { useHits, useSearchBox } from "react-instantsearch";
import { sortResultsByRelevance } from "../services/relevance-scoring";

function HitsWithRelevanceScoring({
  hitComponent: HitComponent,
  classNames = {},
  escapeHTML,
  transformItems,
  casesPerPage,
  ...rest
}) {
  const { hits, items, sendEvent } = useHits(
    { escapeHTML, transformItems },
    { $$widgetType: "ais.hits" }
  );
  const { query } = useSearchBox();
  const shouldShowScore = query.trim().length > 0 && query.trim() !== "*";
  const rawHits = items ?? hits ?? [];
  const reranked = sortResultsByRelevance(rawHits);
  const groupedHits = reranked.length > 0 ? reranked : rawHits;
  const displayHits =
    typeof casesPerPage === "number" && casesPerPage > 0
      ? groupedHits.slice(0, casesPerPage)
      : groupedHits;

  const listClassName = ["ais-Hits-list", classNames.list].filter(Boolean).join(" ");
  const itemClassName = ["ais-Hits-item", classNames.item].filter(Boolean).join(" ");
  const rootClassName = ["ais-Hits", classNames.root].filter(Boolean).join(" ");

  return (
    <div {...rest} className={rootClassName}>
      <ol className={listClassName}>
        {displayHits.map((hit) => (
          <li
            key={hit.objectID ?? hit.primary_key ?? hit.chunk_id}
            className={itemClassName}
            onClick={() => sendEvent?.("click:internal", hit, "Hit Clicked")}
            onAuxClick={() => sendEvent?.("click:internal", hit, "Hit Clicked")}
          >
            <HitComponent hit={hit} sendEvent={sendEvent} showScore={shouldShowScore} />
          </li>
        ))}
      </ol>
    </div>
  );
}

export default HitsWithRelevanceScoring;
